import { AppDispatch, RootState, store } from '../index';
import { FetchState } from '../fetchState';
import { InvitationTypeVisitListResponse } from '@qcs/safety-client';
import { getList, getListSort, ListFilter, listSlice, ListType } from '../listHelper';
import { CancelToken } from 'axios';
import { invitationVisitService } from '@api/services/services';

export type InvitationTypeVisitListState = ListType<InvitationTypeVisitListResponse, ListFilter>;

const initialState: InvitationTypeVisitListState = {
  state: FetchState.None,
  data: undefined,
  query: {
    sortBy: 'lastName',
    sortDesc: false,
  },
};

export const invitationTypeVisitListSlice = listSlice({
  name: 'invitationTypeVisitList',
  initialState,
});

export const selectInvitationTypeVisitList = (state: RootState) => state.invitationTypeVisitList;
export const invitationTypeVisitListActions = invitationTypeVisitListSlice.actions;

export const getInvitationTypeVisitList = (cancelToken: CancelToken) => (dispatch: AppDispatch) => {
  const storeState = store.getState();
  const data = selectInvitationTypeVisitList(storeState);

  const handleGetData = (size: number) => {
    return invitationVisitService.queryInvitationTypeVisit(
      {
        q: data.query.q,
        page: data.query.page,
        size: size,
        sort: getListSort(data),
      },
      { cancelToken: cancelToken }
    );
  };

  getList({
    dispatch,
    cancelToken,
    state: data.state,
    actions: invitationTypeVisitListActions,
    getData: handleGetData,
  });
};
